import { pct } from "../../lib/api";

/** Field labour hours against the estimate's hours, per scope. Display only — this panel
 *  never writes to Field and never moves a budget number. */
export default function HoursPanel({ hours }) {
  const rows = hours?.rows || [];
  if (!rows.length) {
    return (
      <div className="rounded-xl border border-slate-200 bg-white px-4 py-3 text-xs text-slate-500"
           data-testid="ops-budget-hours-empty">
        No published scope hours on this project yet — publish them from the estimate's scope
        hours screen and the field's assigned hours will read against them here.
      </div>
    );
  }
  return (
    <div className="overflow-hidden rounded-xl border border-slate-200 bg-white"
         data-testid="ops-budget-hours">
      <div className="flex flex-wrap items-center gap-3 border-b border-slate-100 px-4 py-2.5">
        <h4 className="text-sm font-semibold text-slate-900">Labour hours by scope</h4>
        <span className="text-xs text-slate-500">
          {hours.totals.actual_hours} of {hours.totals.budgeted_hours} budgeted hours assigned
          in the field · as of {hours.as_of}
        </span>
      </div>
      <table className="w-full text-sm">
        <thead className="bg-slate-50 text-[11px] uppercase tracking-wide text-slate-500">
          <tr>
            <th className="px-4 py-2 text-left">Scope</th>
            <th className="px-3 py-2 text-right">Budgeted hrs</th>
            <th className="px-3 py-2 text-right">Field hrs</th>
            <th className="px-3 py-2 text-right">Variance</th>
            <th className="px-3 py-2 text-right">Used</th>
            <th className="px-3 py-2 text-right">Installed</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          {rows.map((r) => (
            <tr key={r.scope_code} className={r.over ? "bg-rose-50/60" : ""}
                data-testid={`ops-budget-hours-${r.scope_code}`}>
              <td className="px-4 py-2 font-mono text-xs">{r.scope_code}</td>
              <td className="px-3 py-2 text-right tabular-nums">{r.budgeted_hours}</td>
              <td className="px-3 py-2 text-right tabular-nums">{r.actual_hours}</td>
              <td className={`px-3 py-2 text-right tabular-nums ${r.variance_hours < 0 ? "font-semibold text-rose-700" : ""}`}>
                {r.variance_hours}
              </td>
              <td className="px-3 py-2 text-right tabular-nums">{pct(r.used_pct)}</td>
              <td className="px-3 py-2 text-right tabular-nums">{pct(r.percent_complete)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <p className="border-t border-slate-100 px-4 py-2 text-[11px] text-slate-400">{hours.note}</p>
    </div>
  );
}
